var _style, _rect, _path, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#14B4C2;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13,
    y1: 50.6523,
    x2: 13,
    y2: 1.2677,
    gradientTransform: "matrix(1 0 0 -1 0 26.2677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14B4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14B4C2",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,1c0.6,0,1,0.4,1,1v22c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1H24 M24,0H2C0.9,0,0,0.9,0,2 v22c0,1.1,0.9,2,2,2h22c1.1,0,2-0.9,2-2V2C26,0.9,25.1,0,24,0L24,0z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    className: "st1",
    width: 26,
    height: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.9,19.7h3.4v1.6H6.8v-1.5l2.5-4.1c1-1.5,1.2-2.3,1.2-3.2c0-0.8-0.4-1.2-1-1.2c-0.7,0-1,0.4-1,1.2v0.7H6.8 v-0.5c0-1.9,1-3,2.7-3s2.8,1.1,2.8,2.8c0,1.2-0.4,2.3-1.5,4.1L8.9,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,18.7v-0.3l1.7-0.2v0.4c0,0.9,0.4,1.3,1,1.3s1-0.4,1-1.1v-2.7c0-0.7-0.4-1-0.9-1c-0.6,0-1.1,0.4-1.1,1.1 v0.2h-1.7V9.9h5v1.6h-3.3v2.9c0.2-0.4,0.9-0.8,1.7-0.8c1.3,0,2.1,0.9,2.1,2.3v2.9c0,1.7-1,2.8-2.7,2.8S13.6,20.4,13.6,18.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDays);
export default __webpack_public_path__ + "static/media/icon-days.7277029c57892cf58fcd6d15aec94d58.svg";
export { ForwardRef as ReactComponent };